import type { Energy } from "../types/vtc";

/**
 * Filter and sort options for the public marketplace pages. The vehicles
 * themselves come from the API (lib/marketplaceApi); UI copy lives in src/i18n.
 */

export const FILTER_ENERGIES: Energy[] = ["Electric", "Hybrid", "Plug-in hybrid", "Diesel", "Petrol"];
export const FILTER_TRANSMISSIONS = ["Automatic", "Manual"];
export const FILTER_CATEGORIES = ["Sedan", "Premium sedan", "Estate", "SUV"];
export const FILTER_MAKES = ["Tesla", "Toyota", "Mercedes-Benz", "Peugeot", "Hyundai", "Kia", "Skoda", "Renault"];

/** Longest minimum duration the driver accepts, in days (0 = any); labels in t.filters.durations. */
export const DURATION_OPTIONS = [0, 7, 14, 30] as const;

/** Labels in t.vehicles.sortOptions. */
export const SORT_KEYS = ["default", "price-asc", "price-desc", "available"] as const;
export type SortKey = (typeof SORT_KEYS)[number];

/* ---------- For companies ---------- */

export const SERVED_AREAS = [
  ["Paris", "Roissy-CDG", "Orly"],
  ["Saint-Denis", "Créteil", "Nanterre"],
  ["Boulogne-Billancourt"],
];
